module.exports = __webpack_public_path__ + "img/1.9db21d32.jpg";